import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserModuleStatisticOutput } from 'infrastructure/graphql/content/user/model/user-module-statistic.output';

import { ApiQuery } from '../../../../common/model/api.query';

@Injectable({ providedIn: 'root' })
export class FetchModulesStatisticQuery extends ApiQuery<
	UserModuleStatisticOutput[],
	void
> {
	client = 'content';
	document = gql`
		query FetchUserModulesStatistic {
			fetchUserModulesStatistics {
				organizationModuleId
				statistic
				priority
				text
			}
		}
	`;
	method = 'fetchUserModulesStatistics';
}
